import { render, staticRenderFns } from "./LightPackageGuidelinesModal.vue?vue&type=template&id=fd380f24&scoped=true"
import script from "./LightPackageGuidelinesModal.vue?vue&type=script&lang=js"
export * from "./LightPackageGuidelinesModal.vue?vue&type=script&lang=js"
import style0 from "./LightPackageGuidelinesModal.vue?vue&type=style&index=0&id=fd380f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd380f24",
  null
  
)

export default component.exports